import React from "react";
import { Cloud, CloudOff, Loader2, Check } from "lucide-react";

export default function SyncBadge({ status }) {
  const map = {
    loading: { icon: Loader2, t: "Loading…", c: "text-zinc-400", spin: true },
    saving: { icon: Loader2, t: "Saving…", c: "text-sky-300", spin: true },
    saved: { icon: Check, t: "Saved to cloud", c: "text-emerald-400" },
    error: { icon: CloudOff, t: "Offline — saved locally", c: "text-amber-400" },
    idle: { icon: Cloud, t: "Cloud sync", c: "text-zinc-500" },
  };
  const s = map[status] || map.idle;
  return (
    <div data-testid="sync-status" data-status={status} className={`flex items-center gap-1.5 text-[11px] ${s.c}`} title={s.t}>
      <s.icon className={`w-3.5 h-3.5 ${s.spin ? "animate-spin" : ""}`} /><span className="hidden lg:inline">{s.t}</span>
    </div>
  );
}
